var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center mt-4"},[_c('b-pagination',{attrs:{"per-page":_vm.perPage,"total-rows":_vm.total},model:{value:(_vm.currentPageModel),callback:function ($$v) {_vm.currentPageModel=$$v},expression:"currentPageModel"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }